<template>
  <div class="stateInventory responsive-menu">
    <div class="responsive-menu__child">
      <PageHeader title="Journal Ledger Upload" :links="[
        { name: 'home', label: 'Home' },
        { name: 'reports', label: 'Reports' },
        { name: 'financeReport', label: 'Finance' },
        {
          name: 'financeJournalLedgerUpload',
          label: 'Journal Ledger Upload',
        },
      ]" @export="exportToCsv" :disableExport="!reportData" />
      <br class="no-print" />
      <ReportFilter class="no-print" :filterByTime="true" @submit-filter="performGetReport" :isLoading="isLoading"
        :percentage="percentageCompleted" :filterBySaleType="false" />
      <div class="report-container">
        <!-- This could be a component -->
        <div class="report-body" v-if="reportData">
          <table id="table-report">
            <thead>
              <tr>
                <th align="left">id_no</th>
                <th align="left">gl_batch_no</th>
                <th align="left">enter_date</th>
                <th align="left">enter_time</th>
                <th align="left">entered_by</th>
                <th align="left">accn</th>
                <th align="left">accn_name</th>
                <th align="left">accn_type</th>
                <th align="left">dr_post</th>
                <th align="left">cr_post</th>
                <th align="left">invoice_id_no</th>
                <th align="left">invoice_item_id_no</th>
                <th align="left">pord_id_no</th>
                <th align="left">pord_item_id_no</th>
                <th align="left">vend_id_no</th>
                <th align="left">cust_id_no</th>
                <th align="left">payment_id_no</th>
                <th align="left">history</th>
                <th align="left">cm_id_no</th>
                <th align="left">store_id</th>
                <th align="left">gl_batch_no_orig</th>
                <th align="left">cannabis</th>
                <th align="left">store_credit</th>
                <th align="left">cust_type</th>
              </tr>
            </thead>

            <tbody>
              <tr class="report-body__row"></tr>
              <tr v-for="(record, index) in reportData.records" :key="index">
                <td align="left">{{ record.id_no }}</td>
                <td align="left">{{ record.gl_batch_no }}</td>
                <td align="left">{{ record.enter_date }}</td>
                <td align="left">{{ record.enter_time }}</td>
                <td align="left">{{ record.entered_by }}</td>
                <td align="left">{{ record.accn }}</td>
                <td align="left">{{ record.accn_name }}</td>
                <td align="left">{{ record.accn_type }}</td>
                <td align="left">{{ record.dr_post }}</td>
                <td align="left">{{ record.cr_post }}</td>
                <td align="left">{{ record.invoice_id_no }}</td>
                <td align="left">{{ record.invoice_item_id_no }}</td>
                <td align="left">{{ record.pord_id_no }}</td>
                <td align="left">{{ record.pord_item_id_no }}</td>
                <td align="left">{{ record.vend_id_no }}</td>
                <td align="left">{{ record.cust_id_no }}</td>
                <td align="left">{{ record.payment_id_no }}</td>
                <td align="left">{{ record.history }}</td>
                <td align="left">{{ record.cm_id_no }}</td>
                <td align="left">{{ record.store_id }}</td>
                <td align="left">{{ record.gl_batch_no_orig }}</td>
                <td align="left">{{ record.cannabis }}</td>
                <td align="left">{{ record.store_credit }}</td>
                <td align="left">{{ record.cust_type }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/Header/Header.vue";
import { mapActions, mapGetters } from "vuex";
import ReportFilter from "@/components/ReportFilter/ReportFilter";
import Utilities from "@/lib/Utilities";
import ReportHelper from "@/lib/report/index.js";

export default {
  data() {
    return {
      Utilities,
    };
  },
  components: {
    PageHeader,
    ReportFilter,
  },
  created: function () {
    this.setPageTitle("Journal Ledger Upload");
  },
  computed: {
    ...mapGetters({
      isLoading: "reports/isLoading",
      getData: "reports/getData",
      percentageCompleted: 'reports/percentageCompleted'
    }),
    reportData() {
      return this.getData;
    },
  },
  methods: {
    ...mapActions({
      generateReport: "reports/generate",
      clearData: "reports/clearData",
    }),
    performGetReport(filter) {
      let reportType = "financeJournalLedgerUpload";
      this.generateReport({
        reportType,
        ...filter,
      });
    },
    exportToCsv() {
      var table = document.getElementById("table-report");
      ReportHelper.exportToExcel(table, "BC_DF-import-GL-transactions");
    },
  },
  beforeDestroy() {
    this.clearData()
  }
};
</script>

<style lang="scss">
@import "./_financeJournalLedgerUpload.scss";
</style>